<!-- ============================================================== -->
<!-- Main wrapper - style you can find in pages.scss -->
<!-- ============================================================== -->
<div class="main-container" [dir]="dir"
  [ngClass]="{'danger': danger, 'blue': blue, 'green': green }">

  <div class="main-content-container">
    <mat-sidenav-container>
      <!-- ============================================================== -->
      <!-- Page container - style you can find in pages.scss -->
      <!-- ============================================================== -->
      <mat-sidenav-content class="page-wrapper">
        <div *ngIf="showLoadingBar | async">
          <mat-progress-bar mode="indeterminate" color="accent"></mat-progress-bar>
        </div>
        <div class="page-content">
          <router-outlet>
            <app-spinner></app-spinner>
          </router-outlet>
        </div>
      </mat-sidenav-content>
      <!-- ============================================================== -->
      <!-- Page container - style you can find in pages.scss -->
      <!-- ============================================================== -->
    </mat-sidenav-container>
  </div>
</div>